import api from './api';

const BASE_PATH = '/documents/investment-sheets';

export const documentService = {
  upload: (sheetId: string, docType: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`${BASE_PATH}/${sheetId}/${docType}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  getDownloadUrl: (sheetId: string, docType: string) => {
    const baseURL = api.defaults.baseURL || '/api';
    return `${baseURL}${BASE_PATH}/${sheetId}/${docType}`;
  },

  download: (sheetId: string, docType: string) => {
    return api.get(`${BASE_PATH}/${sheetId}/${docType}`, {
      responseType: 'blob',
    });
  },

  delete: (sheetId: string, docType: string) => {
    return api.delete(`${BASE_PATH}/${sheetId}/${docType}`);
  },
};
